<template>
  <div class="knd-scrolly" >
    <div class="knd-scrolly-container" ref="scrolly">

      <div class="knd-steps" ref="steps">

       <div class="knd-intro-steps">
          <!-- <Rope /> -->
            <div 
              v-for="(stap, index) in data.intro"
              :index="index"
              :key="'intro-' + index" >
            
            <div class="knd-step knd-wrapper" >
              <div class="card">
               <div v-html="stap.text"></div>
              </div>
            </div>
          </div>
        </div>

      <div class="knd-persons-container">
      <div 
        v-for="(rol, index) in data.rol" 
        :class="{'last-step': index === data.rol.length-1}"
        class="knd-person-container" 
        :key="'rol-' + index" 
      >

        <ScrollSection 
          class="sticky-person"
          :call-back="(e) => onEnter(e, index, rol.title, true)"
          :index="index"
          :key="index" 
        >
        <Person :rol="rol" />
        </ScrollSection>

        
        <div class="knd-step knd-step-intro knd-wrapper">
          <p>{{rol.intro}}</p>
        </div>

        <div class="knd-step knd-wrapper step-audio-block">
          <blockquote class="knd-quote">
            <p>
              {{rol.quote}}
            </p>
          </blockquote>


          <AudioSyncComp :activeOption="rol" />
        </div>
    </div>
  </div>

      </div>

      <div class="knd-scrolly-bg knd-scrolly-bg-zoom" ref="scrollybg">

<svg ref="svgcontainer" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1038 785" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g class='phone'>
    <image x="0" y="0" width="1038" height="785" :xlink:href="ASSETS + '' + data.phone.data.attributes.url" />
    <!-- <image ref="display" x="813" y="176" width="195" height="321" :xlink:href=getClassIcon() /> -->
    <image ref="display" x="813" y="176" width="195" height="321" :href="`${publicPath}/images/Telefoon-zoom-4.png`" />

    <rect width="1038" height="785" fill="url(#pattern0)"/>
    <rect x="813" y="176" width="195" height="321" fill="url(#pattern1)"/>
    <rect id='branchevereniging' x="827" y="191" width="44" height="18" fill="#D9D9D9" fill-opacity="0.5"/>
    <rect id='journalisten' x="826" y="312" width="47" height="19" fill="#D9D9D9" fill-opacity="0.5"/>
    <rect id='telefoniste'  x="949" y="281" width="48" height="20" fill="#D9D9D9" fill-opacity="0.5"/>
    <rect id='escortdame' x="950" y="341" width="48" height="20" fill="#D9D9D9" fill-opacity="0.5"/>
    <rect id='eigenaar' x="947" y="432" width="48" height="20" fill="#D9D9D9" fill-opacity="0.5"/>
    <rect id='klant' x="825" y="433" width="47" height="18" fill="#D9D9D9" fill-opacity="0.5"/>
  </g>

  <defs>
    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlink:href="#image0_0_1" transform="matrix(0.000256082 0 0 0.000338615 0 -0.00132005)"/>
    </pattern>
    <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlink:href="#image1_0_1" transform="matrix(0.00135747 0 0 0.000810793 -0.164103 -0.34782)"/>
    </pattern>
  </defs>
</svg>
</div>
    </div>
</div>
</template>

<script>
  import ScrollSection from "./ScrollSection.vue";
  import Person from '../person';
  import AudioPlayer from '@/components/audioplayer';
  import AudioSyncComp from '../audiosync';
  import Rope from '@/story/rope';

  import * as d3 from 'd3';

  import { useStore } from 'vuex'
  import { ref, onMounted } from 'vue';

export default {
  components:{ScrollSection, Person, AudioPlayer, AudioSyncComp, Rope},
  setup () {
    const store = useStore()

    const ASSETS = ref(process.env.VUE_APP_ASSETS);
    let steps = ref(undefined);
    let display = ref(undefined);
    let svgcontainer = ref(undefined);
    let currentStep = ref(0);

    onMounted(() => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) return;
          reset();

          // console.log("ZOOMOUT");
      });

      // start observing
      intersectionObserver.observe(document.querySelector(".knd-intro-steps"));

      const intersectionObserverPersons = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) return;
          zoomInON();

          // console.log("ZOOMIN");
      });

      // start observing
      intersectionObserverPersons.observe(document.querySelector(".knd-persons-container"));

    })

    const onEnter = (e, index, title, person) => {
        let elSteps = steps.value.querySelectorAll('.knd-step');
        currentStep.value = 'Stap ' + index;

        elSteps.forEach((el, i) => {
          el.classList.remove('active');
          if(index === i) {
            el.classList.add('active');
          }
        })
    }

    const reset = () => {
      let container = d3.select('svg .phone');

      let scale = 1;
      container
      .transition().duration(2000)
      .attr("transform", "translate(0,0)scale(1,1)");
    }

    const zoomInON = () => {      
      let selected = display.value;
      var transform = getTransform(selected, 2.5);

      let container = d3.select('svg .phone');
            
      container.transition().duration(2000)
        .attr("transform", "translate(" + transform.translate + ")scale(" + transform.scale + ")");
    }

    function getTransform(node, xScale) {
      let svgContainer = svgcontainer.value;

      let containter = d3.select('svg .phone');
      let containterBBox = containter.node().getBBox();

      let vw = containterBBox.width;
      let vh = containterBBox.height;
      let vx = containterBBox.x;
      let vy = containterBBox.y;

      let bbox = node.getBBox();
      var bx = bbox.x;
      var by = bbox.y;
      var bw = bbox.width;
      var bh = bbox.height;
      var tx = -bx*xScale + vx + vw/2 - bw*xScale/2;
      var ty = -by*xScale + vy + vh/2 - bh*xScale/2;
      return {translate: [tx, ty], scale: xScale}
    }

    const onClickVolume = () => {
     store.dispatch('toggleSound');
    }

    return {
      data: store.getters.data,
      steps,
      display,
      svgcontainer,
      ASSETS,
      onEnter,
      onClickVolume,
      store,
      publicPath: process.env.VUE_APP_PATH
    }
  }
}

</script>

<style lang="scss">

  .knd-scrolly {
    --stepper-color: #FFF;
    --stepper-margin: 0 auto;
    
    transition: background .2s ease-in;
    background: var(--stepper-background);
    color: var(--stepper-color);
    
    @include md { 
      --stepper-margin: 0 10vw 0 auto;
    }

    .scrollStep {
      // margin-bottom: 50vh;
      min-height: 10px;
      
    }
  }

.knd-scrolly-container {
  position: relative;
  max-width: 1440px;

  @include md { 
     margin:0 10vw 0 auto;
    }
}

.knd-scrolly-bg {
    position: sticky;
    margin-left: 5vw;
		top: auto;
    bottom: 10vh;
    margin-top:auto;

    overflow:hidden;
    // z-index: 1;

    @include md { 
      margin-left: 0;
      top: 10vh;
    }
    
    svg {
      max-height: 80vh;
      height: 80vh;
      width: 90vw;
      
      @include md { 
        height: inherit;
        width: inherit
      }
    }
	}

  .knd-steps {
    // z-index: 10;
    
    @include sm {
      position: relative;
    }

    .sticky-person .card {
      margin: var(--stepper-margin);
    }

    .knd-step {
      $color-bg: var(--interactive-background, #FFF);

      background: $color-bg;
      padding: var(--stepper-padding);
      position: relative;
      min-width: 300px;
      width: var(--stepper-card-width);

      
      margin: var(--stepper-margin);
      margin-bottom: 20vh;

      opacity: 1;
      z-index: 100;
      filter: drop-shadow(0px 4px 9.2px rgba(0, 0, 0, 0.4));

      transition: opacity .4s ease-in;
      &.active {
        opacity: 1;
      }

      &.knd-wrapper {
        max-width: 640px
      }
    }

    .knd-step-intro {
      padding-bottom: 2rem;

      padding-top: 1rem;

      p {
        margin-bottom: 0;
      }
    }

    blockquote {
      font-weight: 300;
      font-size: 30px;
      text-align: center;
    }
  }

  .sticky-person {
    position: sticky;
    top: -1px;
    height: auto; 
    z-index: 1000;
    padding-top: 1px;

    .card {
      transition: background 0.5s ease;
    }

    &.is-top {
      .card {
        background: #E1E1E1;
        // background: linear-gradient(175.47deg, #E1E1E1 -1.02%, #E1E1E1 70.98%, #A7AAA8 129.27%) !important;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }

  }
  
  .knd-person-container {
    // margin-bottom: 50vh;
    .card {
      $color-bg: var(--interactive-background, #FFF);

      width: 100%;
      max-width: 100%;
      max-width: 640px;
      align-items: center;
      // padding: 0em 2em 2em;

      background:  $color-bg;

      // background: linear-gradient(  $color-bg 4%,  $color-bg 95%,rgba(0,0,0,0) 100%);
    }
  }

  .knd-person-container .scrollStep {
    margin-bottom: 0 !important;
    height: auto;
  }

  .knd-step-quote {
    position: relative;
    text-align: center;
    background: rgb(40 8 106);§
    blockquote {
      margin-bottom: 0;
    }
}

.knd-step .knd-audio-player {
  max-width: 450px;
  margin: 0 auto;
}

.last-step {
    .step-audio-block {
      margin-bottom: 0;
    }
  }
</style>